import {
  SSLErrorsNode,
  NotificationParamsType,
  SSLErrorDetailsType,
  SSLErrorItemType,
  SSLType,
  CustomAddBypassFromNotificationsPayload,
} from 'interfaces'
import Toast from 'components/Basic/Toast'
import {MonolithService, PBFFService} from 'services/api'

export const fetchNotifications = async (
  params: NotificationParamsType,
): Promise<SSLErrorDetailsType> => {
  try {
    const res = await PBFFService.getNotifications(params)
    const notificationData: SSLErrorsNode = res?.data?.ssl_errors || {}
    return parseSSLErrorNotificationResponse(notificationData, params.type)
  } catch (_) {
    // return empty result when API fails
    return Promise.resolve({
      items: [],
      totalAppCount: 0,
      totalUrlCount: 0,
      offset: 0,
      // this ssl view type is required to correctly map data as per view
      sslType: params.type,
    })
  }
}

const parseSSLErrorNotificationResponse = (
  sslErrors: SSLErrorsNode,
  sslType: SSLType,
): SSLErrorDetailsType => {
  const {total_app_count, total_url_count, offset = 0} = sslErrors
  let parsedSSLData: SSLErrorItemType[] = []
  if (sslType === SSLType.app) {
    parsedSSLData =
      sslErrors.apps?.map(app => {
        return {
          processName: app.parent_label,
          errorCount: app.urls?.length,
          childItems:
            app.urls?.map(urlItem => {
              return {
                ...urlItem,
                isSelected: false,
              }
            }) || [],
          userList: app.user_ids || [],
          totalUserCount: app.total_user_count,
          childSelection: false,
          expand: false,
          isSelected: false,
        }
      }) || []
  } else {
    parsedSSLData =
      sslErrors.urls?.map(urlItem => {
        return {
          processName: urlItem.parent_label,
          errorCount: urlItem.urls?.length,
          childItems:
            urlItem.urls?.map(childUrlItem => {
              return {
                ...childUrlItem,
                isSelected: false,
              }
            }) || [],
          userList: urlItem.user_ids || [],
          totalUserCount: urlItem.total_user_count,
          childSelection: true,
          expand: false,
          isSelected: false,
        }
      }) || []
  }

  return {
    items: parsedSSLData,
    totalAppCount: total_app_count,
    totalUrlCount: total_url_count,
    offset,
    // this ssl view type is required to correctly map data as per view
    sslType,
  }
}

export const addBypassViaNotifications = async (
  payload: CustomAddBypassFromNotificationsPayload,
): Promise<void> => {
  try {
    // Keep notification bulk-add on legacy until the backend bulk custom
    // bypass route lands; this path updates all policies in one request.
    await MonolithService.addBypassViaNotifications(payload)
    return Promise.resolve()
  } catch (err) {
    Toast({message: err, type: 'error'})
    return Promise.reject()
  }
}
